<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>
                    <el-select v-model="query.side" size="small" style="width: 120px;margin-right: 20px">
                        <el-option :value="1" label="医生端"></el-option>
                        <el-option :value="0" label="患者端"></el-option>
                    </el-select>
                    <el-select v-model="query.type" size="small" style="width: 120px;margin-right: 20px">                        
                        <el-option v-for="item in types" :key="item.id"
                                :label="item.name" :value="item.id"></el-option>
                    </el-select>
                     <el-button type="primary" @click="search" style="width: 96px;margin-right: 20px">查询</el-button>
                    <el-button type="primary" @click="add()" style="width: 96px">新增</el-button>
                </div>
               
            </div>
            <div>
                <el-table :data="tableData"
                          v-loading="loading"
                          :header-cell-style="{'padding-left': '3%'}"
                          :cell-style="{'padding-left': '3%'}">
                    <el-table-column prop="id" label="ID"></el-table-column>                   
                    
                    <el-table-column label="终端">
                        <template slot-scope="scope">
                            <span v-if="scope.row.side === 1">医生端</span>
                            <span v-else>患者端</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="typeName" label="问题分类"></el-table-column>
                    <el-table-column prop="title" label="问题标题"></el-table-column>
                    <el-table-column prop="content" label="问题内容" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="url" label="网络地址">
                        <template slot-scope="scope">
                            <span v-if="scope.row.url && scope.row.url.indexOf('.png') != -1">
                                <el-popover placement="top-start" trigger="click"> <!--trigger属性值：hover、click、focus 和 manual-->
                                <a :href="scope.row.url" target="_blank" title="查看最大化图片">
                                    <img :src="scope.row.url" style="width: 300px;height: 300px">
                                </a>
                                <img slot="reference" :src="scope.row.url" style="width: 80px;height: 80px; cursor:pointer">
                                </el-popover>
                            </span>
                            
                            <span v-else>{{scope.row.url}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.state === 1">正常</span>
                            <span v-else>删除</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">                        
                        <el-button type="text" @click="edit(scope.row)">查看</el-button>
                        <el-button type="text" @click="del(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>                                        
                    
                </el-table>
            </div>
    
        </div>
        <el-dialog title="新增问题" :visible.sync="dialogAddVisible" width="560px"
                   :close-on-click-modal="false" :before-close="cancelAdd">
            <el-form :model="questionAdd" ref="add" size="small" label-width="90px">

                <el-form-item label="终端:" prop="side">
                   <el-select size="small" style="width: 150px;margin-right: 20px" v-model="questionAdd.side">				
                        <el-option label="患者端" :value="0"></el-option>
                        <el-option label="医生端" :value="1"></el-option>	
					</el-select>
                </el-form-item>

                <el-form-item label="问题分类:" prop="type">
                   <el-select v-model="questionAdd.type" size="small" style="width: 120px;">                        
                        <el-option v-for="item in types" :key="item.id"
                                :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标题:" prop="title">
                    <el-input v-model="questionAdd.title" style="width: 320px"></el-input>
                </el-form-item>
                <el-form-item label="标题内容:" prop="content">
                    <el-input v-model="questionAdd.content" style="width: 320px"></el-input>
                </el-form-item>                
                <el-form-item label="图片:" prop="url">
                       <div style="width: 92px;height: 92px;border:1px dashed rgba(204,204,204,1);">
                            <i class="el-icon-plus push"></i>
                            <el-image v-if="questionAdd.url"  class="course-img" :src="questionAdd.url"></el-image>
                            <input type="file" class="upload-input" @change="addImg" accept="image/*" ref="picture"/>
                        </div>      
                </el-form-item>          
               
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelAdd" style="width: 76px">取 消</el-button>
                <el-button type="primary" @click="confirmAdd" style="width: 76px;">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="编辑问题" :visible.sync="dialogEditVisible" width="560px"
                   :close-on-click-modal="false" :before-close="cancelEdit">
            <el-form :model="questionEdit"  ref="edit" size="small" label-width="90px">
                <el-form-item label="终端:" prop="side">
                   <el-select size="small" style="width: 150px;margin-right: 20px" v-model="questionEdit.side">				
                        <el-option label="患者端" :value="0"></el-option>
                        <el-option label="医生端" :value="1"></el-option>	
					</el-select>
                </el-form-item>

                <el-form-item label="问题分类:" prop="type">
                    <el-select v-model="questionEdit.type" size="small" style="width: 120px;">                        
                        <el-option v-for="item in types" :key="item.id"
                                :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标题:" prop="title">
                    <el-input v-model="questionEdit.title" style="width: 320px"></el-input>
                </el-form-item>
                <el-form-item label="标题内容:" prop="content">
                    <el-input v-model="questionEdit.content" style="width: 320px"></el-input>
                </el-form-item>                
                <el-form-item label="图片:" prop="url">
                       <div style="width: 92px;height: 92px;border:1px dashed rgba(204,204,204,1);">
                            <i class="el-icon-plus push"></i>
                            <el-image v-if="questionEdit.url"  class="course-img" :src="questionEdit.url"></el-image>
                            <input type="file" class="upload-input" @change="addImg" accept="image/*" ref="picture"/>
                        </div>      
                </el-form-item>                     
               
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelEdit" style="width: 76px">取 消</el-button>
                <el-button type="primary" @click="confirmEdit" style="width: 76px;">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>    
    export default {
       
        data() {
            return {
                authorization:localStorage.getItem('authorization'),                
                loading: true,
                tableData: [],
                dialogAddVisible:false,
                query:{
                    side:1,
                    type:'',
                },
                types:[],
                questionAdd:{
                    side:1,
                    type:'',
                    title:'',
                    content:'',
                    url:'',
                    state:1,                   

                },
               
                dialogEditVisible:false,
                questionEdit:{
                    id:'',
                    side:1,
                    type:'',
                    title:'',
                    content:'',
                    url:'',
                    state:1,    
                    
                }
                
               
            };
        },
        methods: {
            // 获取科室列表
            getData() {
                this.loading = true                
                this.axios.get('api-b/10057/100570',{
                    params:{
                        type:this.query.type,
                        side:this.query.side
                    },
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    console.log(res.data)
                    if (res.data.code === 10000) {
                        if (res.data.data.length === 0) {
                            this.$message.info('暂无数据')
                        }
                        this.tableData = res.data.data
                        
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []
                        
                    }
                    this.loading = false
                }).catch(error => {
                    this.tableData = []
                    
                    this.loading = false
                })
            },
           getType() {               
                this.axios.get('api-b/10056/100560/1',{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.types = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            search(){
                this.getData()       
            },
        cancelAdd() {
            this.dialogAddVisible = false
            this.$nextTick(() => {
                this.$refs.add.resetFields()
            })
        },
        // 新增科室弹窗按钮
        add() {            
            this.dialogAddVisible = true
        },
        uploadImg(data) {
            return new Promise(resolve => {
                this.axios.post('/api-f/10027/100065',data,{
                    headers:{
                        Authorization: this.authorization,
                        'Content-Type':'multipart/form-data'
                    }
                }).then(res => {
                    resolve(res)
                })
            })
        },
        addImg(){
            let inputDOM = this.$refs.picture;
            let file = inputDOM.files[0];
            let params = new FormData()
            params.append('file',file)
            params.append("pathPrefix",'question')
            this.uploadImg(params).then(res => {
                if (res.data.code === 10000) {
                    this.$message.success(res.data.message)
                    this.questionAdd.url = res.data.data.fileUrl
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },
        confirmAdd(){
            this.$refs.add.validate(valid => {                                            
                let params = {
                    side:this.typeAdd.side,
                    name:this.typeAdd.name,
                    state:this.typeAdd.state,                   
                                                
                }
                this.axios.post('api-b/10057/100571/',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.dialogAddVisible = false
                        this.$message.success(res.data.message)
                        this.getData()
                    
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
                
            })

        },
        cancelEdit() {
                this.dialogEditVisible = false
                this.$nextTick(() => {
                    this.$refs.edit.clearValidate()
                })
            },
        // 编辑医生弹窗按钮
        edit(data) {
            
            this.axios.get('/api-b/10057/100573/' + data.id,{
            headers:{
                Authorization: this.authorization,
            }
            }).then(res => {
                
                if(res.data.code=== 10000) {
                    if (res.data.data !== null) {
                        this.dialogEditVisible = true
                        this.questionEdit = res.data.data
                        
                    } else {
                        this.$message.info(res.data.message)
                    }
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },
            
        confirmEdit() {
            this.$refs.edit.validate(valid => {                
                let params = {
                    id:this.typeEdit.id,
                    side:this.typeEdit.side,
                    name:this.typeEdit.name,
                    state:this.typeEdit.state                   
                                                
                }
                this.axios.post('/api-b/10057/100571',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.dialogEditVisible = false
                        this.$message.success(res.data.message)
                        this.getData()
                        this.$nextTick(() => {
                            this.$refs.edit.resetFields()                            
                        })
                    } else {
                        this.$message.error(res.data.message)
                    }
                })

               
            })
        },
       
        del(data){
            const h = this.$createElement;
            this.$msgbox({
                message: h('div',{class:'message-box'}, [
                    h('div', { class: 'message-title-box'}, [
                        h('i', { class:'el-icon-warning message-box-icon' }, ''),
                        h('span', { class:'message-box-title'}, '确认要删除该问题吗？'),
                    ]),
                    
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {                
                
                this.axios.get('/api-b/10057/100572/' + data.id,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                        this.getData()
                    }
                }).catch(error => {})
            })

        }

           
        },
        watch: {
            
        },
        created() {
            this.getData()
            this.getType()            
        }
    };
</script>

<style>

</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
    .dialog-set{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }
    .tag-box {
        width: 288px;
        min-height: 30px;
        border-radius: 5px;
        border: 1px solid #DCDFE6;
        padding: 0 15px
    }
    .push {
        color:rgba(238,238,238,1);
        font-size: 32px;
        position: absolute;
        top: 30px;
        left: 30px;
    }
    .course-img {
        position: absolute;
        top: 1px;
        width: 92px;
        height: 92px;
    }
     .upload-input {
        opacity: 0;
        width: 92px;
        height: 92px;
        position: absolute;
        top: 0;
    }
</style>